// extracted by mini-css-extract-plugin
export default {"navlinks":"navlinks_navlinks__6OxXw"};